Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-track-trace'),
        $trackTraceForm = $('.x-track-trace-form');

    var model = null;
    var wrapper = $wrapper;

    if ($wrapper.length < 1)
        return;

    var trackTraceForm = $trackTraceForm.get(0);

    var formData = {
        providerId: 0,
        voucherCode: '',
        orderCode: ''
    };

    trackTraceForm.reset = function () {
        $('input[name="orderCode"]', $trackTraceForm).val("");
        $('select[name="dlProviderId"] option:selected', $trackTraceForm).prop("selected", false);
        var voucherId = getQueryStringValueByName('voucher');
        if (!voucherId) {
            $('.js-voucher', $trackTraceForm).addClass('hide');
            $('input[name="voucherCode"]', $trackTraceForm).val("");
        }
        
    }

    wrapper.update = function update() {
        wrapper.loading(true);

        var html = Vendd.Handlebars.parse("trackTraceReview_A", model);
        wrapper.bind(html);
        
        wrapper.loading(false); 
      
    }; 

    wrapper.bind = function bind(html) {
        wrapper.html(html);
    };
     
    $trackTraceForm.on('click', '.tab-title', function () {
           
        var thisTab = $(this);
        var innerWrapper = thisTab.closest('.x-tab-panel');
        var thisTabIndex = thisTab.data('tab-index');

        $('li[data-tab-content-index=' + thisTabIndex + ']', innerWrapper).children('.mb-title').addClass('icon-arrow-up').removeClass('icon-arrow-down');
        $('li[data-tab-content-index=' + thisTabIndex + ']', innerWrapper).siblings().children('.mb-title').removeClass('icon-arrow-up').addClass('icon-arrow-down');

        thisTab.addClass('active').siblings().removeClass('active');
        $('li[data-tab-content-index=' + thisTabIndex + ']', innerWrapper).addClass('active').siblings().removeClass('active');

        trackTraceForm.reset();
        $('.x-voucher',$wrapper).empty();
       
    });


    $trackTraceForm.on('change', '.js-select', function () {
        $('.js-voucher', $trackTraceForm).removeClass('hide');
    });

    $trackTraceForm.on('click', '.js-submit-button', function (e) {
        e.preventDefault();
        e.stopPropagation();
        wrapper.loading(true);

        if ($('.tab-content.active', '.x-tab-panel').hasClass('voucher')) {
            if ($('select[name="dlProviderId"]').length > 0) {
                if ($('select[name="dlProviderId"]').val() && $('select[name="dlProviderId"]').val() == 0) {
                    return;
                }
            } else if (!($trackTraceForm.data('default-provider'))) {
                return;
            }
        } else if ($('.tab-content.active', '.x-tab-panel').hasClass('order')) {
            if ($('input[name="orderCode"]').val()  === undefined) {
                return;
            }
        }
     
        trackTraceForm.submit();
        
       
       
    });


    trackTraceForm.submit = function () {
        trackTraceForm.loading(true);

        if ($('.tab-content.active', '.x-tab-panel').hasClass('voucher')) {
            formData.voucherCode = $('input[name="voucherCode"]').val();
            formData.orderCode = undefined;
            formData.providerId = ($('select[name="dlProviderId"]').length > 0) ? $('select[name="dlProviderId"]').val() : $trackTraceForm.data('default-provider');


        } else if ($('.tab-content.active', '.x-tab-panel').hasClass('order')) {
            formData.voucherCode = undefined;
            formData.orderCode = $('input[name="orderCode"]').val();
            formData.providerId = undefined;

        }

        Vendd.MessageBus.publishAsync(wrapper.get(0), new Vendd.TrackTrace.Messages.GetTrackTraceModel(formData.voucherCode, formData.orderCode, formData.providerId));
    };

    trackTraceForm.loading = function (loading) {
        if (loading) {
            $trackTraceForm.addClass('x-loading');
        } else {
            $trackTraceForm.removeClass('x-loading');
        }
    };

    wrapper.loading = function loading(loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };
    Vendd.MessageBus.subscribe(Vendd.TrackTrace.Messages.GetTrackTraceModelSuccess, wrapper, function (envelope) {

        model = envelope.message.data.model;
        wrapper.update();
    });

});